/**
 * Created by amirb on 5/23/16.
 */
define(function (require) {


    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var SlaChangerListViewController = require('web-agent-viewControllers/SlaChangerListViewController');
    var ViewController = require('web-agent-framework/ViewController');

    var PhotoPreviewViewController = ViewController.extend({
        ControllerName: 'PhotoPreviewViewController',

        LPViewMap : {
            left:'.lpview_left_btn',
            right:'.lpview_right_btn',
            close:'.close_btn',
            download:'.lpview_header_download',
            noPreviewIcon: '.lpview_no_preview_icon',
            noPreviewMessage: '.lpview_no_preview_message_text',
            photoView:'.LP_photo_view',
            header:'.header',
            image:'.img_src',
            footer:'.footer',
            imageContainer:'.img_container',
            iFrame:'.lpview_iframe',
            imageIndexTitle: '.image_index_display',
            strip:'.strip',
            caption: '.caption',
            time: '.time_info'
        },

        IMAGE_TYPES: ['JPG', 'JPEG', 'PNG', 'GIF'],

        initialize: function (constructorData) {
            this.chatId = constructorData.chatId;
            this.initView();
        },

        events: function () {
            this.bindViewEvent({selector : this.LPViewMap.close, DOMEvent : "click", callback : this.hideView});
            this.bindViewEvent({selector : this.LPViewMap.left, DOMEvent : "click", callback : this.switchLeft});
            this.bindViewEvent({selector : this.LPViewMap.right, DOMEvent : "click", callback : this.switchRight});
        },

        render: function () {

        }
    });

    PhotoPreviewViewController.prototype.hideView = function () {
        if (this.visible) {
            this.lpHide(this.LPViewMap.photoView);
            this.visible = false;

            this.unbindModel({modelPath: this.imagesModelPath, callback: this.updatedImageArray});
        }
    };

    PhotoPreviewViewController.prototype.showView = function (data) {
        this.imagesModelPath = 'images.' + data.conversationId;
        this.bindModel({modelPath: this.imagesModelPath, callback: this.updatedImageArray});
        this.imagesArray = this.getModelParam(this.imagesModelPath);

        this.currentIndex = this.getImageIndex(data);
        this.createPhotoView();
        this.showImage();

        this.visible = true;
        this.lpShow(this.LPViewMap.photoView);
    };

    PhotoPreviewViewController.prototype.showImage = function () {
        this.showLoading();
        this.updateDownloadImageUrl(this.imagesArray[this.currentIndex], this.updateDataAndRender);
    };

    PhotoPreviewViewController.prototype.showError = function () {
        this.addClass(this.imageContainer, 'error');
        this.removeClass(this.imageContainer, 'loading');
        this.removeClass(this.imageContainer, 'no_preview');
    };

    PhotoPreviewViewController.prototype.updateDataAndRender = function () {
        this.imagesArray = this.getModelParam(this.imagesModelPath);
        this.setImageSource();
    };

    PhotoPreviewViewController.prototype.setImageSource = function () {
        var url = this.imagesArray[this.currentIndex].event.message.imageUrl;
        var type = _getFileTypeFromFileName(_getFileNameFromURL(url));
        if (this.IMAGE_TYPES.indexOf(type) >= 0) {
            this.setAttribute(this.image, 'src', url);
        } else {
            this.hideLoading();
            this.addClass(this.imageContainer, 'no_preview');
        }
    };

    PhotoPreviewViewController.prototype.updatedImageArray = function (data) {
        this.imagesArray = this.getModelParam(this.imagesModelPath);

        this.updateTexts();
        this.toggleArrowState();
    };

    PhotoPreviewViewController.prototype.updateTexts = function () {
        var indexOutOfImagesTitle = this.translateObj('photo_sharing_view_index', [this.currentIndex + 1, this.imagesArray.length]);
        this.imageIndexTitle.innerHTML = indexOutOfImagesTitle;

        var captionText = this.getCurrentCaption();
        this.caption.title =this.caption.innerHTML = captionText;
        this.time.innerHTML = this.formatTime(this.imagesArray[this.currentIndex].time);};

    PhotoPreviewViewController.prototype.getCurrentCaption = function () {
        if (!this.imagesArray || !this.imagesArray[this.currentIndex]) {
            return '';
        }

        if (!this.imagesArray[this.currentIndex].event || !this.imagesArray[this.currentIndex].event.message) {
            return '';
        }

        if (!this.imagesArray[this.currentIndex].event.message.caption) {
            return '';
        }

        return this.imagesArray[this.currentIndex].event.message.caption;
    };

    PhotoPreviewViewController.prototype.createPhotoView = function () {
        if (this.currentView) {
            this.removeView({view: this.currentView});
        }
        this.imagesArray = this.getModelParam(this.imagesModelPath);

        var imageViewController = this.getFirstElement('.content_placeholder');
        var listTemplate = require('web-agent-templates/LP_image_view_data.html');
        // var listTemplate = lpUtils.loadResource('web-agent-templates/LP_image_view_data.html');

        var indexOutOfImagesTitle = this.translateObj('photo_sharing_view_index', [this.currentIndex + 1, this.imagesArray.length]);
        listTemplate = this.injectTextDefaults(listTemplate, {
            indexOutOfImagesTitle: indexOutOfImagesTitle,
            sender: this.imagesArray[this.currentIndex].by,
            caption: this.getCurrentCaption(),
            time: this.formatTime(this.imagesArray[this.currentIndex].time)
        });

        this.currentView = this.createView({template: listTemplate, wrapWithDiv: false, target: imageViewController});
        this.bindViewEvent({selector:  this.LPViewMap.strip, DOMEvent : "mouseover" , callback : this.displayStrip});
        this.bindViewEvent({selector:  this.LPViewMap.strip, DOMEvent : 'mouseleave', callback: this.hideStrip});
        this.bindViewEvent({selector:  this.LPViewMap.image,  DOMEvent : "mouseover" , callback : this.displayStrip});
        this.bindViewEvent({selector:  this.LPViewMap.image,  DOMEvent : 'mouseleave', callback: this.hideStrip});
        this.bindViewEvent({selector:  this.LPViewMap.download, DOMEvent : "click" , callback : this.downloadImage});
        this.bindViewEvent({selector:  this.LPViewMap.noPreviewIcon, DOMEvent : "click" , callback : this.downloadImage});
        this.bindViewEvent({selector:  this.LPViewMap.noPreviewMessage, DOMEvent : "click" , callback : this.downloadImage});
        this.bindViewEvent({selector: 'body', DOMEvent: "keyup", callback: this.keyUpPressed});

        this.image = this.getFirstElement(this.LPViewMap.image);
        this.headerElement = this.getFirstElement(this.LPViewMap.header);
        this.footerElement = this.getFirstElement(this.LPViewMap.footer);
        this.iframe = this.getFirstElement(this.LPViewMap.iFrame);
        this.imageContainer = this.getFirstElement(this.LPViewMap.imageContainer);
        this.imageIndexTitle = this.getFirstElement(this.LPViewMap.imageIndexTitle);
        this.caption = this.getFirstElement(this.LPViewMap.caption);
        this.time = this.getFirstElement(this.LPViewMap.time);};

    PhotoPreviewViewController.prototype.hideLoading = function () {
        clearTimeout(this.timeoutId);
        this.removeClass(this.imageContainer, 'loading');
    };

    PhotoPreviewViewController.prototype.showLoading = function () {
        clearTimeout(this.timeoutId);
        this.removeClass(this.imageContainer, 'error');
        this.removeClass(this.imageContainer, 'no_preview');
        this.addClass(this.imageContainer, 'loading');

        var self = this;

        this.timeoutId = setTimeout(function () {
            self.showError();
        }, 60000);

        this.image.onload = (function (loadId) {
            clearTimeout(loadId);
            if (loadId === self.timeoutId) {
                self.hideLoading();
            }
        }).bind(self, this.timeoutId);

        this.image.onerror = (function (loadId) {
            clearTimeout(loadId);
            if (loadId === self.timeoutId) {
                self.showError();
            }
        }).bind(self, this.timeoutId);
    };

    PhotoPreviewViewController.prototype.initView = function () {
        var photosButtonsControllerTemplate = require('web-agent-templates/LP_photo_view_controllers.html');
        // var photosButtonsControllerTemplate = lpUtils.loadResource('web-agent-templates/LP_photo_view_controllers.html');
        this.createView({template: photosButtonsControllerTemplate, wrapWithDiv: false});
    };

    PhotoPreviewViewController.prototype.switchRight = function () {
        if (this.imagesArray && this.imagesArray.length > this.currentIndex + 1) {
            this.currentIndex++;
            this.showImage();
        }
        this.toggleArrowState();
    };

    PhotoPreviewViewController.prototype.switchLeft = function () {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.showImage();
        }
        this.toggleArrowState();
    };

    PhotoPreviewViewController.prototype.toggleArrowState = function () {
        this.toggleRightArrowState();
        this.toggleLeftArrowState();
        this.updateTexts();
    };

    PhotoPreviewViewController.prototype.toggleRightArrowState = function () {
        var right;
        if (!this.imagesArray) {
            return;
        }
        right = this.getFirstElement(this.LPViewMap.right);
        if (this.imagesArray.length === this.currentIndex + 1) {
            this.addClass(right, 'disabled');
        } else {
            this.removeClass(right, 'disabled');
        }
    };

    PhotoPreviewViewController.prototype.toggleLeftArrowState = function () {
        var left = this.getFirstElement(this.LPViewMap.left);
        if (this.currentIndex > 0) {
            this.removeClass(left, 'disabled');
        } else {
            this.addClass(left, 'disabled');
        }
    };

    PhotoPreviewViewController.prototype.getImageIndex = function (data) {
        return _.findIndex(this.imagesArray, function(item) { return item.id == data.id; });
    };

    PhotoPreviewViewController.prototype.updateDownloadImageUrl = function (data, doneHandler) {
//    if(!data || !data.event || !data.event.message || !data.event.message.relativePath) {
////        return;
//    }

        this.modelController.getDownloadUrl({
            conversationId: data.conversationId,
            latestAgentId: data.latestAgentId,
            pathUrl: data.event.message.relativePath,
            index: this.currentIndex,
            done: doneHandler.bind(this),
            lastUrl: data.event.message.imageUrl,
            isHistory: data.isHistory
        });
    };

    PhotoPreviewViewController.prototype.displayStrip = function () {
        this.addClass(this.headerElement, 'no_opacity');
        if (this.shouldShowFooterStrip()) {
            this.addClass(this.footerElement, 'no_opacity');
        }
    };

    PhotoPreviewViewController.prototype.hideStrip = function () {
        this.removeClass(this.headerElement, 'no_opacity');
        this.removeClass(this.footerElement, 'no_opacity');
    };

    PhotoPreviewViewController.prototype.shouldShowFooterStrip = function () {
        if (this.getCurrentCaption() !== '') {
            return true;
        }
        return false;

    };

    PhotoPreviewViewController.prototype.downloadImage = function () {
        this.updateDownloadImageUrl(this.imagesArray[this.currentIndex], onDownloadURLReceived);

        function onDownloadURLReceived(data) {
            this.imagesArray = this.getModelParam(this.imagesModelPath);
            this.openFileDownloadDialog();
        }
    };

    PhotoPreviewViewController.prototype.openFileDownloadDialog = function () {
        if (!this.imagesArray || !this.imagesArray[this.currentIndex] || !this.imagesArray[this.currentIndex].event || !this.imagesArray[this.currentIndex].event.message) {
            return;
        }

        var url = this.imagesArray[this.currentIndex].event.message.imageUrl;

        window.open(url, '_blank');
    };

    PhotoPreviewViewController.prototype.keyUpPressed = function (e) {
        var keyCode = e.keyCode || e.which;
        switch (keyCode) {
            case 37: /* LEFT */
                this.switchLeft();
                break;
            case 39: /* RIGHT */
                this.switchRight();
                break;
            case 27: /* ESC */
                this.hideView();
                break;
        }
    };

    function _getFileNameFromURL(url) {
        if (!url || typeof url !== 'string') {
            return '';
        }
        return url.split('/').pop().split('\\').pop().split('?')[0];
    }

    function _getFileTypeFromFileName(name) {
        if (!name) {
            return '';
        }
        return name.split('.').pop().toUpperCase();
    }

    return PhotoPreviewViewController;

});
